import styled from '../styled-components';

export default styled.div`
    margin-right: auto;
    margin-left: auto;
    max-width: 1040px;
    padding-right: 1rem;
    padding-left: 1rem;
`;



// WEBPACK FOOTER //
// ./src/components/Container.tsx